/* globals localStorage */
import axios from "axios";
import querystring from "querystring";
var config = require("../conf.json");
const aconf = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded"
  }
};
const BASE_URL = config.server;

export default {
  login(email, pass, cb) {
    cb = arguments[arguments.length - 1];
    // if (localStorage.token) {
    if (getCookie("token")) {
      if (cb) cb(true);
      this.onChange(true);
      return;
    }
    loginrequest(email, pass, res => {
      if (res.authenticated) {
        setCookie("token", res.token, 2);
        if (cb) cb(true);
        this.onChange(true);
      } else {
        if (cb) cb(false);
        this.onChange(false);
      }
    });
  },

  registerForNewsletter(email, first, last, gender) {
    const url = BASE_URL + config.user + "/newsletterabo";
    //console.log(email + " " + first + " " + last + " " + gender);
    return axios.post(url, {
      username: email,
      firstname: first,
      lastname: last,
      gender: gender
    });
  },

  register(email, pass, first, last, gender, letter, cb) {
    const url = BASE_URL + config.user + "/create/ki";
    let bo ={username: email,
      password: pass,
      firstname: first,
      lastname: last,
      gender: gender,
      newsletter: letter}
    return axios.post(url, bo);
  },

  getToken() {
    return getCookie("token");
    //return localStorage.token;
  },
  logout(cb) {
    //delete localStorage.token;
    setCookie("token", "", 10000);
    setCookie("trainer", false, 10000);
    if (cb) cb();
    this.onChange(false);
  },

  loggedIn() {
    return !!getCookie("token");
    //return !!localStorage.token;
  },
  isTrainer() {
    return !!getCookie("trainer");
    //return !!localStorage.token;
  },

  onChange() {},

  checkUsername(username) {
    const url = BASE_URL + config.user + "/exists/" + username;
    return axios.get(url).then(response => response.data);
  }
};

function loginrequest(email, pass, cb) {
  //console.log("requesting login");
  const url = BASE_URL + "/authentication";
  axios
    .post(
      url,
      querystring.stringify({ username: email, password: pass }),
      aconf
    )
    .then(res => {
      console.log(res.data);
      if (res.data.token) {
        setCookie("trainer", res.data.trainer, 2);
        cb({
          authenticated: true,
          token: res.data.token
        });
      } else {
        cb({ authenticated: false });
      }
    })
    .catch(err => {
      //console.log(err);
      cb({ authenticated: false });
    });
}

function setCookie(cname, cvalue, exhours) {
  var d = new Date();
  d.setTime(d.getTime() + exhours * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
